import moment from 'moment';

// Filtros da Conferência (/conferencia), guardados com usePersistedFilters.
// Mês como 'YYYY-MM' (nunca moment).

export var CONFERENCE_FILTERS_KEY = 'conferencia';

export var getDefaultConferenceFilters = function() {
  return {
    month: moment().format('YYYY-MM'),
    stateFilter: null,
    deptFilter: null,
    search: '',
  };
};

// Mês salvo inválido (ou ausente) volta para o padrão.
export var normalizeMonth = function(month, fallback) {
  var parsed = month ? moment(month, 'YYYY-MM', true) : null;
  if (parsed && parsed.isValid()) return parsed.format('YYYY-MM');
  return fallback;
};

// Badge: conta só o que difere do padrão.
export var getConferenceFilterCount = function(filters, defaults) {
  return (filters.stateFilter ? 1 : 0) +
    (filters.deptFilter ? 1 : 0) +
    (filters.search ? 1 : 0) +
    (filters.month !== defaults.month ? 1 : 0);
};

// O departamento automático (ex.: Fiscal para o grupo Fiscal) só vale numa
// visita "do zero": se a página abriu com filtros mantidos, o que foi
// restaurado (inclusive "todos os departamentos") é a escolha do usuário.
export var shouldApplyAutoDept = function(params) {
  if (params.alreadyApplied || params.restored) return false;
  if (params.loading || params.loadedMonth !== params.month) return false;
  if (params.deptFilter) return false;
  var tasks = params.tasks || [];
  if (!params.dept || tasks.length === 0) return false;
  return tasks.some(function(task) { return task.department === params.dept; });
};

// Só a resposta do pedido mais recente vale: trocar de mês rápido não pode
// mostrar as tarefas de um mês que já não está selecionado.
export var createLatestRequestGuard = function() {
  var latest = 0;
  return {
    next: function() {
      latest += 1;
      return latest;
    },
    isLatest: function(id) {
      return id === latest;
    },
  };
};
